import * as React from "react";
const SvgArrowBullet = (props) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 14, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m1.147 6.998 8.693.006M5.5 1.5 11 7l-5.5 5.5", stroke: "#5ECBCC", strokeWidth: 1.8, strokeMiterlimit: 10 }));
export default SvgArrowBullet;
